import store from "./store";
import { types } from "./reducers/app_reducer";

function setLoading(loading = false) {
  store.dispatch({
    type: types.SET_LOADING,
    payload: { loading },
  });
}

function toggleSidebar() {
  store.dispatch({ type: types.TOGGLE_SIDEBAR });
}

const actions = {
  setLoading,
  toggleSidebar,
};

export { store as default };
export { types, actions };
